import {
  CovideoGTMVideoMessageProperties,
  GTMVideoMessageProperties,
} from './types';

export function mapToGtmVideoMessageProperties(
  item?: CovideoGTMVideoMessageProperties
): GTMVideoMessageProperties {
  if (!item) return {} as GTMVideoMessageProperties;

  return {
    customer_id: item?.customerId || undefined,
    sms: item?.sms || undefined,
    email: item?.email || undefined,
    notification_viewed: item?.notificationViewed || false,
    landing_page: item?.landingPage || undefined,
    call_to_action: item?.callToAction || undefined,
    thumbnails: item?.thumbnails || undefined,
  };
}

export function getVideoDurationMs(
  file: File,
  timeoutMs = 8000
): Promise<number> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const video = document.createElement('video');

    video.preload = 'metadata';
    video.muted = true;
    (video as any).playsInline = true;

    let settled = false;
    const timer = setTimeout(
      () => fail(new Error('Timed out reading video duration')),
      timeoutMs
    );

    const cleanup = () => {
      clearTimeout(timer);
      video.removeEventListener('loadedmetadata', onLoadedMetadata);
      video.removeEventListener('canplay', onCanPlay);
      video.removeEventListener('timeupdate', onTimeUpdate);
      video.removeEventListener('error', onError);
      URL.revokeObjectURL(url);
      video.removeAttribute('src');
      try {
        video.load();
      } catch {}
    };

    const finish = (ms: number) => {
      if (settled) return;
      settled = true;
      cleanup();
      resolve(Math.round(ms));
    };

    const fail = (err: Error) => {
      if (settled) return;
      settled = true;
      cleanup();
      reject(err);
    };

    const onTimeUpdate = () => {
      if (isFinite(video.duration) && video.duration > 0) {
        finish(video.duration * 1000);
      }
    };

    const forceComputeDuration = () => {
      // force a seek to end; some browsers compute duration only after a seek
      video.addEventListener('timeupdate', onTimeUpdate);
      try {
        video.currentTime = 1e101;
      } catch {
        setTimeout(() => {
          try {
            video.currentTime = Number.MAX_VALUE;
          } catch {}
        }, 0);
      }
    };

    const onLoadedMetadata = () => {
      if (isFinite(video.duration) && video.duration > 0) {
        finish(video.duration * 1000);
      } else {
        forceComputeDuration();
      }
    };

    const onCanPlay = () => {
      if (isFinite(video.duration) && video.duration > 0) {
        finish(video.duration * 1000);
      }
    };

    const onError = () => fail(new Error('Failed to load video metadata'));

    video.addEventListener('loadedmetadata', onLoadedMetadata);
    video.addEventListener('canplay', onCanPlay);
    video.addEventListener('error', onError);

    // Start loading
    video.src = url;
    try {
      video.load();
    } catch {}
  });
}
